import React from "react";
import ReactApexChart from "react-apexcharts";

/**
 * Komponen Chart untuk menampilkan rekapan per puskesmas
 * @param {Array} data - Data rekapan per puskesmas
 */
export default function RekapanPuskesmasChart({ data }) {
  if (!data || data.length === 0) {
    return (
      <div className="text-center p-4">
        <p className="text-muted">Tidak ada data untuk ditampilkan</p>
      </div>
    );
  }

  // Prepare data for chart - ambil top 10 puskesmas
  const sortedData = [...data]
    .sort((a, b) => (b.total_masuk || 0) - (a.total_masuk || 0))
    .slice(0, 10);

  const lokasi = sortedData.map((item) => item.lokasi || "N/A");
  const totalMasuk = sortedData.map((item) =>
    parseFloat(item.total_masuk || 0)
  );
  const totalKeluar = sortedData.map((item) =>
    parseFloat(item.total_keluar || 0)
  );
  const stok = sortedData.map((item) => parseFloat(item.stok || 0));

  const chartData = {
    series: [
      {
        name: "Total Masuk",
        type: "column",
        data: totalMasuk,
      },
      {
        name: "Total Keluar",
        type: "column",
        data: totalKeluar,
      },
      {
        name: "Stok",
        type: "line",
        data: stok,
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
        toolbar: {
          show: false,
        },
      },
      stroke: {
        curve: "straight",
        width: [0, 0, 2],
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [2],
        style: {
          fontSize: "10px",
          fontWeight: 500,
        },
        formatter: function (val) {
          // Format dalam ribuan
          if (val >= 1000000) {
            return (val / 1000000).toFixed(1) + "M";
          } else if (val >= 1000) {
            return (val / 1000).toFixed(1) + "K";
          }
          return val;
        },
      },
      labels: lokasi,
      xaxis: {
        type: "category",
        labels: {
          rotate: -45,
          rotateAlways: true,
          style: {
            fontSize: "10px",
          },
        },
      },
      yaxis: {
        title: {
          text: "Nilai (Rp)",
        },
        labels: {
          formatter: function (value) {
            if (value >= 1000000) {
              return (value / 1000000).toFixed(1) + "M";
            } else if (value >= 1000) {
              return (value / 1000).toFixed(1) + "K";
            }
            return value;
          },
        },
      },
      colors: ["#4D53E0", "#FF5668", "#43BC13"],
      legend: {
        position: "top",
      },
      plotOptions: {
        bar: {
          columnWidth: "50%",
        },
      },
    },
  };

  return (
    <ReactApexChart
      options={chartData.options}
      series={chartData.series}
      type="line"
      height={350}
    />
  );
}
